var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongXiaoxi2Mian1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.333 7.667c0 3.682-3.208 6.666-7.166 6.666-.96 0-1.875-.175-2.711-.493l-2.606.388a.333.333 0 01-.372-.415l.428-1.62C1.723 11.006 1 9.415 1 7.668 1 3.985 4.209 1 8.167 1c3.958 0 7.166 2.985 7.166 6.667zm-10-1.207a.58.58 0 011.105.347l-.57 1.818a.58.58 0 11-1.106-.348l.57-1.817zm5.911-.406a.58.58 0 00-.578.406l-.57 1.817a.58.58 0 001.105.348l.571-1.818a.58.58 0 00-.528-.753zM8 6.46a.58.58 0 011.107.347l-.571 1.818a.58.58 0 11-1.106-.348l.57-1.817z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_xiaoxi2_mian1.9310e41b.svg";
export { SvgTongyongXiaoxi2Mian1 as ReactComponent };